import { Component, OnInit } from '@angular/core';

import { DataManager } from 'techlify-ng';
import { RequestErrorService } from "techlify-ng";

import { Facility } from 'school-mis-core';
import { FacilityDataService } from "school-mis-core";

/**
 * Controller used to view all Facilities.
 * 
 * @author Floyd Kissoon
 * @since 20181002
 */
@Component({
    selector: 'facility-view-all',
    templateUrl: './facility-view-all.html'
})
export class FacilityViewAllComponent implements OnInit {
    private items: Facility[];
    private filters: any;

    constructor(private dataManager: DataManager, private errorHandler: RequestErrorService, private dataService: FacilityDataService) {
        this.filters = {};
        this.filters.sort_by = "id|DESC";
    }

    ngOnInit() {
        this.loadData();
    }

    loadData() {
        this.dataService.getPublicFacilities(this.filters).then(
            res => {
                this.items = res.items;
            }
        );
    }
}
